// FactoringCalculator.js
import React, { useState } from 'react';

const FactoringCalculator = () => {
  const [input, setInput] = useState('');
  const [factors, setFactors] = useState([]);

  const findFactors = () => {
    const num = parseInt(input);
    if (isNaN(num) || num <= 0) {
      setFactors(['Please enter a positive integer.']);
      return;
    }

    const result = [];
    for (let i = 1; i <= Math.sqrt(num); i++) {
      if (num % i === 0) {
        result.push(i);
        if (i !== num / i) result.push(num / i);
      }
    }
    setFactors(result.sort((a, b) => a - b));
  };

  return (
    <section className="min-h-screen bg-[#02042b] text-white flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-xl bg-white/10 backdrop-blur-lg p-8 rounded-2xl shadow-2xl border border-white/20">
        <h1 className="text-3xl font-extrabold mb-6 text-center">Factoring Calculator</h1>
        <input
          type="number"
          placeholder="Enter a positive integer"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="w-full p-4 border border-white/20 bg-white/5 text-white placeholder-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        />
        <button
          onClick={findFactors}
          className="mt-6 w-full bg-gradient-to-r from-blue-600 to-teal-500 text-white font-semibold px-6 py-3 rounded-lg hover:scale-105 transition duration-300"
        >
          Calculate Factors
        </button>

        {factors.length > 0 && (
          <div className="mt-6 p-4 bg-white/10 rounded-lg border border-white/20">
            <h3 className="text-white font-bold mb-2">Factors:</h3>
            <p className="text-green-300">{factors.join(', ')}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default FactoringCalculator;
